var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BookModel } from "../../models/BookModel";
var CourseParticipantModel = /** @class */ (function (_super) {
    __extends(CourseParticipantModel, _super);
    function CourseParticipantModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CourseParticipantModel.prototype.personalData = function () {
        return this.hasOne('personal_data', 'personalData');
    };
    CourseParticipantModel.prototype.timespan = function () {
        return this.hasOne('course_timespans', 'courseTimespan');
    };
    CourseParticipantModel.prototype.prepareBookingsRow = function (placement) {
        var _a, _b;
        var timespan = this.timespan();
        return __assign(__assign({}, ((_a = timespan === null || timespan === void 0 ? void 0 : timespan.prepareAsRow({
            placement: placement,
            dataColumns: ["course", "place", 'appointments', 'appointmentlist', 'info', 'infolink'],
            titleKey: "timespan_format"
        })) !== null && _a !== void 0 ? _a : {})), { id: this.id, bookingid: this.get("unique_id"), cancellink: this.get("presented.cancelLink"), timespan: timespan === null || timespan === void 0 ? void 0 : timespan.get("presented.courseTitles"), fullname: (_b = this.personalData()) === null || _b === void 0 ? void 0 : _b.get("full_name"), dueamount: this.get("presented.formattedDueAmount"), bills: this.get("presented.bills") });
    };
    return CourseParticipantModel;
}(BookModel));
export { CourseParticipantModel };
